module.exports = require("@ht-web/firebase-adapter");